<h5>{{data.head}}</h5>
<hr/>
<div>
  <p>
   {{data.body}}
  </p>
</div>
<div class="mb-1 mt-1">
  <button mat-button (click)="onNoClick()" color="warn" cdkFocusInitial class="ml-2">Close</button>
</div>